import React, { Component } from 'react'
import { unitProductOperationsService } from '../../_services/unitProductOperations.service'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import QtyInput from '../Shared/QtyInput'
import Loading from '../Shared/Loading'
import AsyncProductSelectByNameAndCode from '../Shared/AsyncProductSelectByNameAndCode'
import { GoPlus } from 'react-icons/go'

const emptyItem = { unitProductId: '', unitProduct: {} }

class WarehouseReceiptProductOperationsTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      // defaultValue: this.props.defaultValue || undefined,
      data: [],
      selected: [],
      dto: {
        brandId: this.props.brandId,
        categoryId: this.props.categoryId,
        unitId: this.props.unitId,
      },
      finalList: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData() {

    if (this.state.dto.unitId) {

      this.setState({ loading: true })
      unitProductOperationsService.getAllProducts(JSON.stringify(this.state.dto))
        .then((res) => {
          console.log(res.data);

          let data = res.data
          this.setState({ data: data, loading: false, isSubmitting: false });
        }).catch((error) => {
          this.setState({ loading: false })
          // console.log(error)
        });

    }

  };


  async componentWillReceiveProps(nextProps) {

    let dto = this.state.dto;

    // if (nextProps.defaultValue !== this.state.defaultValue) {
    //   this.setState({ defaultValue: nextProps.defaultValue });
    // }
    // if (nextProps.categoryId !== this.state.dto.categoryId) {
    //   dto["categoryId"] = nextProps.categoryId;
    //   // this.setState({ dto: dto, data: [] }, () => {
    //   //   this.getData();
    //   // });
    // }
    // if (nextProps.brandId !== this.state.dto.brandId) {
    //   dto["brandId"] = nextProps.brandId;
    //   // this.setState({ dto: dto, data: [] }, () => {
    //   //   this.getData();
    //   // });
    // }
    // if (nextProps.unitId !== this.state.dto.unitId) {
    //   dto["unitId"] = nextProps.unitId;
    // }

    if (nextProps.dto != undefined && nextProps.dto !== this.state.dto) {
      dto = nextProps.dto;
      this.setState({ dto: dto, data: [] }, () => {
        this.getData();
      });
    }

  }



  handleQuantityChange = (e, unitProductId, conversionUnit) => {

    let quantity = e.target.value;

    let subQuantity = undefined;

    if (quantity != undefined && conversionUnit != undefined) {
      // subQuantity = Math.round(quantity / conversionUnit)
      subQuantity = Number((quantity / conversionUnit).toFixed(3))
    }

    let list = this.state.finalList;

    let index = list.findIndex(el => el.unitProductId === unitProductId);

    if (index > -1) {
      list[index].quantity = quantity;
      list[index].subQuantity = subQuantity;
    } else {
      let obj = {};
      obj["unitProductId"] = unitProductId;
      obj["quantity"] = quantity;
      obj["subQuantity"] = subQuantity;
      list.push(obj)
    }

    this.setState({ finalList: list }, () => {

      this.props.onChange(list);

    })
  }

  handleSubQuantityChange = (e, unitProductId, conversionUnit) => {

    let subQuantity = e.target.value;

    let quantity = undefined;

    if (subQuantity != undefined && conversionUnit != undefined) {
      // quantity = Math.round(subQuantity * conversionUnit)
      quantity = Number((subQuantity * conversionUnit).toFixed(3))
    }

    let list = this.state.finalList;

    let index = list.findIndex(el => el.unitProductId === unitProductId);

    if (index > -1) {
      list[index].quantity = quantity;
      list[index].subQuantity = subQuantity;

    } else {
      let obj = {};
      obj["unitProductId"] = unitProductId;
      obj["quantity"] = quantity;
      obj["subQuantity"] = subQuantity;
      list.push(obj)
    }

    this.setState({ finalList: list }, () => {

      this.props.onChange(list);

    })

  }

  handleDelete = (index) => {

    // let finalList = this.state.finalList;
    let data = this.state.data;

    // finalList = finalList.filter(el => el.unitProductId != unitProductId);
    data.splice(index, 1)


    this.setState({ data: data }, () => {

      this.props.onChange(data);

    })

  }

  handleUnitProductSelect = (e, index) => {

    let newList = this.state.data;

    newList[index].unitProductId = e.unitProduct.id;
    newList[index].unitProduct = e.unitProduct;

    console.log(newList);

    this.setState({ data: newList }, () => {

      this.props.onChange(newList);

    })

  }

  handleUnitProductQuantityChange = (val, subVal, index) => {

    let newList = this.state.data;

    newList[index].quantity = val;
    newList[index].subQauntity = subVal;

    console.log(newList);

    this.setState({ data: newList }, () => {

      this.props.onChange(newList);

    })

  }

  render() {

    const { data, loading, defaultValue, disabled, finalList } = this.state;
    const { clearable, className, required } = this.props;

    return (
      <div className="warehouse-products-dialog-table">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th className="text-center" style={{ width: 50 }}>ردیف</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">مقدار</th>
              <th className="text-center" style={{ width: 120 }}>حذف از لیست</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? data.map((item, index) => (
              <tr key={'product-item-' + index}>
                <td style={{ width: 50 }}>{index + 1}</td>
                <td>
                  <AsyncProductSelectByNameAndCode
                    unitId={this.props.unitId}
                    onChange={(e) => {
                      // console.log(e.product);
                      this.handleUnitProductSelect(e, index)
                    }}
                  />
                </td>
                <td>
                  {item.unitProduct ?
                    <div>
                      <QtyInput
                        disabled={item.unitProduct.conversionUnit}
                        className="text-input"
                        measurementType={item.unitProduct.measurementType}
                        subMeasurementType={item.unitProduct.subMeasurementType}
                        conversionUnit={item.unitProduct.conversionUnit}
                        onChange={(val, subVal) => {
                          this.handleUnitProductQuantityChange(val, subVal, index)
                        }}
                      // defualtValue={item.quantity}
                      // defualtSubValue={item.subQuantity}
                      />
                      {/* <ErrorMessage component={ErrorPopUp} name={`items[${index}].quantity`} style={{ margin: '0 auto' }} /> */}
                    </div>
                    : ''}
                </td>
                <td style={{ width: 120 }}>
                  <a onClick={() => this.handleDelete(index)}
                    className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn">
                    <IoIosCloseCircleOutline size="24px" />
                  </a>
                </td>
              </tr>
            ))
              :
              <tr>
                <td colSpan="11" style={{ overflow: 'hidden', height: 'calc(100vh - 350px)', position: 'relative' }}>
                  <Loading />
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="5">
                <a
                  onClick={() => {
                    var items_ = this.state.data;
                    var newList = items_.concat({ unitProductId: '', unitProduct: undefined })
                    this.setState({ data: newList })
                  }}
                  className="modal-close-btn">
                  <GoPlus size="20px" />
                </a>
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}
export default WarehouseReceiptProductOperationsTable;
